module.exports = __webpack_public_path__ + "img/6D6050_C8C2B9_A2998E_B4AA9F-256px.74b378f3.png";